import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "rounded-md bg-white shadow-xl dark:bg-darkVeryDarkDesaturatedBlue" }
const _hoisted_2 = {
  key: 1,
  class: "h-56 grid place-content-center"
}
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon h-20 dark:text-gray-400\" viewBox=\"0 0 512 512\"><title>Newspaper</title><path d=\"M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328\" fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"32\"></path><path d=\"M416 464h0a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48z\" fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"32\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"32\" d=\"M240 128h64M240 192h64M112 256h192M112 320h192M112 384h192\"></path><path d=\"M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z\"></path></svg>", 1)
const _hoisted_5 = { class: "dark:text-gray-400" }
const _hoisted_6 = {
  key: 2,
  class: "p-5 flex justify-between text-gray-500"
}
const _hoisted_7 = { class: "text-sm font-medium text-gray-900 capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_to_do_task_item = _resolveComponent("to-do-task-item")!
  const _component_notification = _resolveComponent("notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.fetchStatusTodo.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fetchStatusTodo, (todo, index) => {
            return (_openBlock(), _createBlock(_component_to_do_task_item, {
              class: "border-b dark:border-gray-700",
              key: index,
              todo: { ...todo, index: index }
            }, null, 8, ["todo"]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, " No " + _toDisplayString(_ctx.status === "all" ? "" : _ctx.status) + " todos at this time. ", 1)
            ])
          ])),
      (_ctx.fetchStatusTodo.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("small", {
              class: _normalizeClass({ invisible: !_ctx.fetchStatusTodo.length })
            }, _toDisplayString(_ctx.fetchStatusTodo.length) + " item" + _toDisplayString(_ctx.fetchStatusTodo.length > 1 ? "s" : "") + " left", 3),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearSelection())),
              type: "button",
              class: "capitalize text-sm"
            }, " clear " + _toDisplayString(_ctx.status), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_notification, {
      show: _ctx.notification,
      onClosenotification: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closenotification($event)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.todoNotificationTitle), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}